import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Form, Row, Col } from 'react-bootstrap';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';

const PatientReplacementRow = ({ patient, selectedValue, onChange, error }) => {
  const badgeLabel =
    patient.dependency_type === 'nurse'
      ? 'Nurse'
      : patient.dependency_type === 'case_manager'
      ? 'Case Manager'
      : 'Nurse & Case Manager';
  const badgeBg =
    patient.dependency_type === 'nurse'
      ? 'primary'
      : patient.dependency_type === 'case_manager'
      ? 'success'
      : 'info';

  const mappedOptions = (patient.replacement_candidates || []).map(user => ({
    value: user.id,
    label:
      `${user.first_name || ''} ${user.last_name || ''}`.trim() ||
      user.email ||
      `User #${user.id}`
  }));

  const resolveValue = id => {
    if (id == null || id === '') return null;
    return mappedOptions.find(option => String(option.value) === String(id));
  };

  return (
    <Row className="g-3 align-items-center py-2">
      <Col md={5}>
        <div className="fw-semibold text-700 fs-10 mb-1">
          {patient.first_name} {patient.last_name}
        </div>
        <Badge bg={badgeBg} className="fw-semibold fs-11">
          {badgeLabel}
        </Badge>
      </Col>
      <Col md={7}>
        <Form.Group>
          <ThemedSelect
            isClearable={false}
            placeholder={`Select ${badgeLabel} Replacement`}
            classNamePrefix="react-select"
            className={error ? 'is-invalid fs-10' : 'fs-10'}
            options={mappedOptions}
            value={resolveValue(selectedValue)}
            onChange={option => onChange(option ? option.value : null)}
          />
          {error && (
            <Form.Control.Feedback type="invalid" className="d-block fs-10">
              {error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
    </Row>
  );
};

PatientReplacementRow.propTypes = {
  patient: PropTypes.shape({
    patient_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    dependency_type: PropTypes.string,
    replacement_candidates: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        email: PropTypes.string
      })
    )
  }).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default PatientReplacementRow;
